import { ORANGE, TEAL, VERT, formatPrix } from './catalogue-utils'

// Carousel « Paniers de la semaine » (paniers precomposes BasketTemplate) — fidele
// prototype v5 (ScreenRayons). AFFICHAGE pour l'instant : vignette, badge de stock,
// nom, description, composition (emojis) et prix de vente force. La commande d'un
// panier (prix force, regle A) arrive dans un increment dedie.

function stockBadge(stock) {
  if (stock <= 0) return { label: 'ÉPUISÉ', bg: 'rgba(7,62,61,0.12)', color: 'rgba(7,62,61,0.6)' }
  if (stock <= 3) return { label: `Plus que ${stock} !`, bg: ORANGE, color: VERT }
  return { label: `${stock} disponibles`, bg: 'rgba(20,184,166,0.18)', color: VERT }
}

export default function PaniersCarousel({ paniers = [], glass, tc, ts }) {
  if (!paniers.length) return null

  return (
    <div className="mb-4">
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] mb-2.5 mx-0.5" style={{ color: TEAL }}>
        Paniers de la semaine
      </p>
      <div className="-mx-4 px-4">
        <div className="flex gap-3 overflow-x-auto pb-1 scrollbar-none">
          {paniers.map((p) => {
            const out = (p.stock ?? 0) <= 0
            const badge = stockBadge(p.stock ?? 0)
            const emojis = (p.composition || []).map((c) => c.emoji).join(' ')
            const heroEmoji = p.composition?.[0]?.emoji || '🧺'
            return (
              <div
                key={p.id}
                className={`flex-shrink-0 w-[210px] rounded-[22px] p-3.5 ${glass} ${out ? 'opacity-55' : ''}`}
              >
                <div className="flex items-start justify-between">
                  {p.photo ? (
                    <span
                      className="w-12 h-12 rounded-[14px] bg-cover bg-center flex-shrink-0"
                      style={{ backgroundImage: `url(${p.photo})` }}
                    />
                  ) : (
                    <span className="text-[34px] leading-none">{heroEmoji}</span>
                  )}
                  <span className="text-[9.5px] font-bold px-2 py-1 rounded-full" style={{ background: badge.bg, color: badge.color }}>
                    {badge.label}
                  </span>
                </div>
                <p className={`font-serif text-[18px] mt-1.5 ${tc}`}>{p.nom}</p>
                {p.description && <p className={`text-[11.5px] ${ts}`}>{p.description}</p>}
                {emojis && (
                  <p className={`text-[12px] mt-1 ${ts}`}>
                    {emojis}{out ? ' · un composant en rupture' : ''}
                  </p>
                )}
                <div className="flex items-center justify-between mt-2.5">
                  <span className={`text-[17px] font-extrabold ${tc}`}>{formatPrix(p.prix)}</span>
                  <span className="text-[10px] font-bold px-2 py-1 rounded-full" style={{ background: 'rgba(7,62,61,0.08)', color: 'rgba(7,62,61,0.55)' }}>
                    Bientôt
                  </span>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
